import React, { Component } from 'react';
import { translate } from 'react-translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEqual } from 'lodash';
import Button from '@components/Button';
import { UPDATE_EMAIL } from '@redux/easyaccess/types';
import * as S from './styles';

class EmailStep extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    email: '',
  };

  componentDidUpdate(prevProps) {
    const {
      props: {
        easyAccessReducer: { step },
      },
    } = this;

    if (!isEqual(prevProps.easyAccessReducer.step.email, step.email) && !step.isLoading) {
      this.setState({
        email: step.email,
      });
    }
  }

  handleSubmit = () => {
    const {
      state,
      props: { token, dispatch },
    } = this;

    dispatch({
      type: UPDATE_EMAIL.REQUEST,
      version: '1.0',
      token,
      body: {
        email: state.email,
      },
    });
  };

  checkEmailIsValid = (e) => {
    const { state } = this;
    const {
      target: { value },
    } = e;

    this.setState({
      ...state,
      email: value,
    });
  };

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  componentDidMount() {
    const {
      props: { email },
    } = this;

    this.setState({
      email,
    });
  }

  render() {
    const {
      state,
      props: { t },
    } = this;

    return (
      <S.EmailStepWrapper>
        <S.EmailTitle>{t('TITLE')}</S.EmailTitle>
        <S.InputWrapper>
          <S.InputEmail
            type="text"
            placeholder="Digite seu e-mail"
            value={state.email}
            onChange={this.handleChange}
          />
        </S.InputWrapper>
        <S.ButtonWrapper>
          <Button backgroundColor="blue2" type="button" onClick={(e) => this.handleSubmit(e)}>
            {t('BUTTON_NEXT')}
          </Button>
        </S.ButtonWrapper>
      </S.EmailStepWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    easyAccessReducer: state.easyAccessReducer,
  };
}

export default withRouter(connect(mapStateToProps)(translate('EmailStep')(EmailStep)));
